<template>

  <Dropdown
      ref="dropdownRef"
      class="User__nav"
      btnClass="User__nav__resume"
      bodyClass="User__nav__more"
  >

    <template v-slot:btn>
      <span class="profil">compte <strong>{{ $page.props.profil }}</strong></span>
      <span class="name">{{ $page.props.current_user.fullname }}</span>
      <span v-if="$page.props.current_office" class="cabinet">
        <Icon name="cabinet-min" />
        <div>
          <span>{{ $page.props.current_office.name }}</span>
          <div class="infos">
            <span><strong>SIRET: </strong>{{ $page.props.current_office.siret }}</span>
            <span><strong>Ref: </strong>{{ $page.props.current_office.matricule }}</span>
          </div>
        </div>
      </span>
    </template>

    <template v-slot:body>
      <div v-if="$page.props.employeur_offices || $page.props.gestionnaire_offices" class="cabinets">
        <template v-if="$page.props.employeur_offices?.length">
          <h4>Mes cabinets</h4>
          <ul>
            <li v-for="office in $page.props.employeur_offices">
              <inertia-link
                  :href="office.link"
                  class="cabinet"
                  :class="{ 'is--active' : office.id == $page.props.current_office.id }"
                  :onSuccess="closeMenu"
              >
                <Icon name="cabinet"/>
                <div>
                  <span class="name">{{ office.name }}</span>
                  <div class="infos">
                    <span><strong>SIRET: </strong>{{ office.siret }}</span>
                    <span><strong>Ref: </strong>{{ office.matricule }}</span>
                  </div>
                </div>
                <Check/>
              </inertia-link>
            </li>
          </ul>
        </template>
        <template v-if="$page.props.gestionnaire_offices?.length">
          <h4>Les cabinets dont je suis le gestionnaire</h4>
          <ul>
            <li v-for="office in $page.props.gestionnaire_offices">
              <inertia-link
                  :href="office.link"
                  class="cabinet"
                  :class="{ 'is--active' : office.id == $page.props.current_office.id }"
                  :onSuccess="closeMenu"
              >
                <Icon name="cabinet"/>
                <div>
                  <span class="name">{{ office.name }}</span>
                  <div class="infos">
                    <span><strong>SIRET: </strong>{{ office.siret }}</span>
                    <span><strong>Ref: </strong>{{ office.matricule }}</span>
                  </div>
                </div>
                <Check/>
              </inertia-link>
            </li>
          </ul>
        </template>
      </div>
      <AppNavAccount @navigated="closeMenu" />
    </template>

  </DropDown>

</template>

<script>
import { user } from '@/store/user'
import { useCabinets } from '@/store/cabinets'
import AppNavAccount from '@components/app/AppNavAccount'
import Icon from '@components/Icon'
import Check from '@components/Check'
import Dropdown from '@components/Dropdown'
import {ref} from "vue";
import {documentsCountByCategory} from "@/store/documents/index";

export default {
  components: {
    Icon,
    Check,
    Dropdown,
    AppNavAccount
  },
  setup(){
    const dropdownRef = ref(null);
    return {
      closeMenu: () => {
        dropdownRef._value?.closeDropdown();
        documentsCountByCategory.value = {};
      },
      dropdownRef
    }
  }
}
</script>

<style lang="scss">
  @import "~@sass/components/UserNav";
</style>
